import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { IsDateString, IsEnum, IsOptional } from "class-validator";
export enum DeliveryStatus {
    IN_INVENTORY = 0,
    SENDING = 1,
    SENT = 2,
    DELIVERED = 3,
    RETURNED = 4
}

class Body {
    @IsEnum(DeliveryStatus)
    status: DeliveryStatus;

    @IsDateString()
    datePaid: Date;
}
export function setInvoiceDeliveryPaymentMethod(instance_id: number, invoice_id: string, body: Body): Promise<AxiosResponse<void>>{
    const path = `/instance/${instance_id}/invoice/${invoice_id}/delivery-payment-status`;
    return Cirus.post(path, body);
}